// Only the pages a candidate opens from a message (upload and chat links); other keys fall back to English.
export default {
  'date.format': 'dd.MM.yyyy',
  'date.format_datetime': 'dd.MM.yyyy HH:mm',

  'common.network_error': 'Si è verificato un errore di rete. Riprovi.',
  'common.loading': 'Caricamento…',

  'candidate.public.error_generic': 'Si è verificato un errore. Riprovi più tardi.',

  'candidate.public_upload.title': 'Carica i tuoi file',
  'candidate.public_upload.intro':
    "{company} le chiede alcune informazioni aggiuntive. Grazie per l'interesse dimostrato per la nostra offerta di lavoro.",
  'candidate.public_upload.intro_no_company':
    "Le sono state richieste alcune informazioni aggiuntive. Grazie per l'interesse dimostrato per la nostra offerta di lavoro.",
  'candidate.public_upload.request_cv': 'Carichi il suo curriculum vitae.',
  'candidate.public_upload.request_reference': 'Carichi le sue lettere di referenza.',
  'candidate.public_upload.request_custom': 'Carichi i file richiesti.',
  'candidate.public_upload.drop_hint': 'Trascini i file qui o clicchi per selezionarli',
  'candidate.public_upload.constraints': 'PDF, Word (.docx), JPG o PNG · max. {size} MB per file · fino a {count} file',
  'candidate.public_upload.remove_file': 'Rimuovi {name}',
  'candidate.public_upload.submit': 'Invia',
  'candidate.public_upload.submit_count': 'Invia {count} file',
  'candidate.public_upload.success_title': 'Grazie!',
  'candidate.public_upload.success_text': 'I suoi file sono stati ricevuti.',
  'candidate.public_upload.fulfilled_title': 'File già ricevuti',
  'candidate.public_upload.fulfilled_text': 'Tramite questo link sono già stati caricati dei file.',
  'candidate.public_upload.cancelled_title': 'Questa richiesta di file è stata ritirata.',
  'candidate.public_upload.expired_title': 'Questo link di caricamento è scaduto.',
  'candidate.public_upload.error_invalid': 'Questo link di caricamento non è valido o è scaduto.',
  'candidate.public_upload.error_duplicate': "«{name}» è già presente nell'elenco.",
  'candidate.public_upload.error_too_many': 'Può caricare al massimo {count} file.',
  'candidate.public_upload.error_too_large': '«{name}» supera i {size} MB.',
  'candidate.public_upload.error_type':
    '«{name}» non è un tipo di file accettato. Utilizzi un file PDF, Word (.docx), JPG o PNG.',
  'candidate.public_upload.upload_failed': 'Il caricamento non è riuscito. Riprovi.',
  'candidate.public_upload.order_finished':
    'Questa offerta di lavoro non è più pubblicata. Non è più possibile caricare file.',

  'candidate.public_chat.title': 'La sua conversazione',
  'candidate.public_chat.title_company': 'La sua conversazione con {company}',
  'candidate.public_chat.intro': 'Legga i messaggi di {company} e risponda qui sotto.',
  'candidate.public_chat.intro_no_company': "Legga i messaggi relativi all'offerta di lavoro e risponda qui sotto.",
  'candidate.public_chat.reply_label': 'La sua risposta',
  'candidate.public_chat.no_messages': 'Ancora nessun messaggio.',
  'candidate.public_chat.reply_placeholder': 'Scriva la sua risposta…',
  'candidate.public_chat.send': 'Invia risposta',
  'candidate.public_chat.reply_error': 'Non è stato possibile inviare la risposta. Riprovi.',
  'candidate.public_chat.error_invalid': 'Questo link della conversazione non è valido o è scaduto.',
  'candidate.public_chat.order_finished':
    'Questa offerta di lavoro non è più pubblicata. La conversazione non è più disponibile.',
};
